<template>
    <div>
        <Headers :title="title" />
        <img class="GDTE" src="~statics/mobileShouye/GDTE.png" alt="">
        <iframe class="iframe" ref="iframe" :src="iframeSrc"  style="border:0;" ></iframe>
        <div class="detaileMenu">
            <img class="detaileMenu-icon" src="~statics/mobileShouye/goback.png" alt=""  @click="toGoback">
            <img class="detaileMenu-icon" src="~statics/mobileShouye/storeMenu.png" alt=""  @click="toStroeCenter">
            <img class="detaileMenu-icon" src="~statics/mobileShouye/cardMenu.png" alt="" @click="toCardCenter">
            <img class="detaileMenu-icon" src="~statics/mobileShouye/rili.png" alt="" @click="goSchedule">
            <img class="detaileMenu-icon" src="~statics/mobileShouye/allExhi.png" alt="" @click="goAllExhibitors">
        </div>
        <!-- <Footers /> -->
    </div>
</template>

<script>
import Headers from "../mobileExhibition/components/Headers"
import Footers from "../mobileExhibition/components/Footers";
import { mapState } from "vuex";
import api from "@/api";

export default {
    components: {
        Footers,
        Headers
    },
    data(){
        return{
            exhibition_id: '',
            entitle: null,
            cntitle: null,
            iframeSrc: ''
        }
    },
    computed: {
        language(){
            return localStorage.getItem('language') || 'zh'
        },
        title(){
            return  this.language == 'zh' ?  this.cntitle : this.entitle
        },
        ...mapState(["userInfo","language"]),
    },
    created() {
        this.exhibition_id = this.$route.query.exhibition_id;
        this.handleGetExhibitor();
        if(this.exhibition_id == '21') {
            this.iframeSrc = `https://720.cloudvhall.com/shidai/map_mobie`;
        } else if(this.exhibition_id == '23') {
            this.iframeSrc = `https://720.cloudvhall.com/shidai/map-cartoon-mobile`;
        } else if(this.exhibition_id == '25') {
            this.iframeSrc = `https://720.cloudvhall.com/shidai/cartoon-mobile`;
        } else if(this.exhibition_id == '34') {
            this.iframeSrc = `https://720.cloudvhall.com/shidai/34-mb-exhi`;
        } else if(this.exhibition_id == '38') {
            this.iframeSrc = `https://720.cloudvhall.com/shidai/38-mb`;
        } else if(this.exhibition_id == '41') {
            this.iframeSrc = `https://720.cloudvhall.com/shidai/41-2.5D-mobile`;
        } else if (this.exhibition_id == '50') {
            this.iframesrc = "https://720.cloudvhall.com/shidai/50-mb";
        } else {  
            this.iframeSrc = `https://720.cloudvhall.com/shidai/${this.exhibition_id}-mobile`;
        }
    },
    mounted(){
        window.addEventListener("message",(res)=>{
            if(res.data && typeof(res.data) == 'string'){
                this.$router.push({
                    path: '/mobileExhibitors',
                })
            }
        });
    },
    methods: {
        toGoback(){
            this.$router.go(-1)
        },
        toStroeCenter(){
            if(!this.userInfo.id){
                this.$notify(this.$t('area').loginTip)
                setTimeout(()=>{
                    this.$router.push({
                        path: '/mobileLogin'
                    },3600)
                })
            }else{
                this.$router.push({
                    path: '/collection'
                })
            }
        },
        toCardCenter(){
            if(!this.userInfo.id){
                this.$notify(this.$t('area').loginTip)
                setTimeout(()=>{
                    this.$router.push({
                        path: '/mobileLogin'
                    },3600)
                })
            }else{
                this.$router.push({
                    path: '/cardHolder'
                })
            }
        },
        goSchedule(){
            this.$router.push({
                path: '/schedule',
                // query: {
                //     exhibition_id: _id
                // }
            })
        },
        goAllExhibitors(){
            this.$router.push({
                path: '/mobilezhanquExhibitor',
                query: {
                    exhibition_id: this.exhibition_id,
                }
            })
        },
         handleGetExhibitor(){
            api.getExhibitor({
                exhibition_id: this.exhibition_id
            }).then((res)=> {
                if(res.res ==1){
                    this.exhibitorData = res.list
                    console.log(this.exhibitorData);
                    this.entitle = res.list[0].vhall.exhibition_name.en.name
                    this.cntitle = res.list[0].vhall.exhibition_name.cn.name
                }else{
                    this.$message.error(res.mes);
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
/deep/ .van-notice-bar__content{
    line-height: .32rem;
    color: #ffffff;
    opacity: 1;
    font-size: 12px
}
/deep/ .van-notice-bar__left-icon{
    color: #fff;
}
/deep/ .van-notice-bar__right-icon{
    color: #fff;
}
/deep/ .van-nav-bar__title{
    color: #fff;
}
/deep/ .van-hairline--bottom{
    background: #194b96;
}
/deep/ .van-icon-search{
    color: #fff;
}
.noticebar{
    width: 6.9rem;
    height: .72rem;
    opacity: 0.6;
    background: #194b96;
    border-radius: 6px;
    position: absolute;
    bottom: 2.2rem;
    left: .3rem;
    right: .3rem;
}
.GDTE{
    width: 3.56rem;
    height: .4;
    margin: .3rem 0 0 .3rem;
    position: absolute;
    z-index: 999;
}
.detaileMenu{
    position: absolute;
    display: flex;
    flex-direction: column;
    bottom: 3.22rem;
    right: .14rem;
    .detaileMenu-icon{
        width: 1.12rem;
        height: 1.12rem
    }
}
.iframe{
    width: 100%;
    border: 0px;
    height: 16.3rem;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}
</style>


// WEBPACK FOOTER //
// src/views/mobile/mobileComponent/index.vue